import { Row, Col, Form } from 'react-bootstrap';
import Required from '../../../utils/Required';

const PasswordFields = ({ formData, onChange, passwordFieldName = 'password' }) => {

  return (
  <Form.Group>
    <Row>
      <Col md={6} className="mb-3">
        <Form.FloatingLabel label={<Required>Password</Required>} controlId="password">
          <Form.Control
            type="password"
            name={passwordFieldName}
            value={formData[passwordFieldName] ?? ''}
            onChange={onChange}
            autoComplete="off"
            placeholder=""
            required
          />
        </Form.FloatingLabel>
      </Col>

      <Col md={6} className="mb-3">
        <Form.FloatingLabel label={<Required>Confirm Password</Required>} controlId="confirm-password">
          <Form.Control
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword ?? ''}
            onChange={onChange}
            isInvalid={
              !!formData.confirmPassword &&
              formData[passwordFieldName] !== formData.confirmPassword
            }
            placeholder=""
            required
          />
        </Form.FloatingLabel>
      </Col>
    </Row>
  </Form.Group>
)};

export default PasswordFields;